export default __webpack_public_path__ + "static/media/koder-icon.b47e00c9.svg";